import Model, { attr, hasMany } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import type { TaskStatus } from 'uplisting-frontend/models/task';

export default class BulkTaskTransitionModel extends Model {
  @attr('string') status!: TaskStatus;
  @attr('array') transitionedIds!: string[];
  @attr('array') rejectedIds!: string[];

  @hasMany('task', { inverse: null, async: false })
  tasks!: ModelRegistry['task'][];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'bulk-task-transition': BulkTaskTransitionModel;
  }
}
